import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import isPropValid from '@emotion/is-prop-valid';
import React, { HTMLProps, useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useDispatch } from 'react-redux';
import { setSectionMounted } from '@/vdp/Device/actions';
import Sections from '~/constants/sections';

export type OwnProps = HTMLProps<HTMLElement> & {
  callback?(): void;
  'data-nav-section'?: Sections;
  threshold?: number;
};

const dummyFunc = () => {};

const SectionViewedLogger: React.FC<OwnProps> = ({
  callback = dummyFunc,
  children,
  id,
  'data-nav-section': dataNavSection = id,
  threshold = 0.33,
  ...propsForElement
}) => {
  const { trackEvent } = useContext(AnalyticsContext);
  const dispatch = useDispatch();
  const [ref, inView] = useInView({
    threshold
  });

  useEffectOnce(
    () => {
      trackEvent(`${dataNavSection}-section-viewed`);
      callback();
    },
    [callback, dataNavSection, trackEvent],
    Boolean(inView && dataNavSection)
  );

  useEffect(() => {
    if (dataNavSection) {
      dispatch(setSectionMounted(dataNavSection));
    }
  }, [dispatch, dataNavSection]);

  // Filter props to only those valid for HTML elements
  const props = Object.entries(propsForElement).reduce<Record<string, any>>(
    (acc, [key, value]) => {
      if (isPropValid(key)) {
        acc[key] = value;
      }

      return acc;
    },
    {}
  );

  return (
    <section data-nav-section={dataNavSection} id={id} ref={ref} {...props}>
      {children}
    </section>
  );
};

export default SectionViewedLogger;
